import { fetchDocsPage, getDocsLogicalPaths } from '~/utils/docs-manifest';
import { getDocsNavTitle } from '~/utils/docs-nav-tree';

const titlesGeneration = ref(0);
const prefetchByLocale = new Map<string, Promise<void>>();

function prefetchDocsLocale(loc: string): Promise<void> {
  const existing = prefetchByLocale.get(loc);
  if (existing) {
    return existing;
  }

  const promise = (async () => {
    const paths = getDocsLogicalPaths().filter(p => p === loc || p.startsWith(`${loc}/`));
    await Promise.all(paths.map(path => fetchDocsPage(path)));
    titlesGeneration.value++;
  })();

  prefetchByLocale.set(loc, promise);
  return promise;
}

/**
 * Prefetch markdown for all pages in a doc locale so nav/breadcrumb labels
 * can use each file's translated H1 title.
 */
export function useDocsNavTitles(locale: MaybeRef<string>) {
  watch(
    () => toValue(locale),
    loc => {
      if (loc) {
        prefetchDocsLocale(loc);
      }
    },
    { immediate: true },
  );

  function getTitle(fullPath: string): string {
    titlesGeneration.value;
    return getDocsNavTitle(fullPath);
  }

  return { getTitle };
}
